// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import BeaconMapController from "./beacon_map_controller"
application.register("beacon-map", BeaconMapController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FriendCodeController from "./friend_code_controller"
application.register("friend-code", FriendCodeController)

import HamburgerController from "./hamburger_controller"
application.register("hamburger", HamburgerController)

import LocaleController from "./locale_controller"
application.register("locale", LocaleController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import ScheduleTableController from "./schedule_table_controller"
application.register("schedule-table", ScheduleTableController)

import SessionsController from "./sessions_controller"
application.register("sessions", SessionsController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import TabController from "./tab_controller"
application.register("tab", TabController)

import WordCounterController from "./word_counter_controller"
application.register("word-counter", WordCounterController)
